// A DESK WALLET OUTSIDE CUSTODY AS A PAYOUT ADDRESS (the wallet's item 6, his own ask, 2 Nov 2026: Hot paying the desk's own
// wallet, e.g. Hot · TRC20 · Oct). The address book lists it beside the customers' and merchants' addresses with `desk: true`,
// its register `class` and the same stages (owner's approval → the test → Received → whitelisted); its id is the register row's.
// Three rules, read here once for every screen that shows or pays one:
//   · its name is the register's (N-091, walletNames() — never the old label, never a party's name);
//   · only Hot pays it;
// The server sends `desk`, `class` (46e436eb) and the register's full name (`name`, 287e25f8: walletNames() tags two wallets of one
// group and month by the day — "Hot · TRC20 · 1 Oct" beside custody's "Hot · TRC20 · 30 Oct"), so the name alone tells them
// apart and no "Desk wallet" label is added (the CC, 3 Nov 2026). An older server without `name`: its class and chain.
import type { WhitelistEntry } from '../../../lib/api';
import { paySources, type PayoutSourceClass } from '../../../lib/custody-screen';
import { walletName } from '../../../lib/custody-format';

type NameField = { name?: { full?: unknown } | null };

export const isDesk = (e: WhitelistEntry): boolean => e.desk === true;

/** Who the address pays, by name: a desk wallet's register name, else the party. */
export function payeeName(e: WhitelistEntry): string {
  if (!isDesk(e)) return e.partyName;
  const n = (e as WhitelistEntry & NameField).name;
  if (n && typeof n === 'object' && typeof n.full === 'string' && n.full) return n.full;
  return e.class ? walletName({ class: e.class, chain: e.chain }) : walletName({ class: 'running_hot', chain: e.chain });
}

/** The wallets that may pay it: Hot alone for a desk wallet; the wallet's own rule (paySources) for everyone else. */
export function sourcesFor(e: WhitelistEntry): PayoutSourceClass[] {
  return isDesk(e) ? ['running_hot'] : paySources(e);
}

/** The payee's kind in one word; null for a desk wallet, whose name says what it is. */
export const payeeKind = (e: WhitelistEntry): string | null =>
  isDesk(e) ? null : e.partyRole === 'merchant' ? 'Merchant' : e.partyRole === 'customer' ? 'Customer' : 'Not said';
